// extracted by mini-css-extract-plugin
export var boxItems = "_cn-1";
export var boxItemsLg = "_cn-2";
export var button = "_cn-7";
export var buttonHoverless = "_cn-9";
export var buttonLg = "_cn-8";
export var filterGroupBox = "_cn-0";
export var icon = "_cn-3";
export var iconSecondary = "_cn-6";
export var iconWrapper = "_cn-4";
export var iconWrapperLg = "_cn-5";
export var truncatedLabel = "_cn-a";